import { useState } from 'react';

import {
  useLocation,
  useNavigate
} from 'react-router-dom';

import { API_BASE } from './config';
import { connectSocket } from '../socket/socket';

import '../css/Login.css';


function Login() {

  /* =================================================
     ROUTER
  ================================================= */

  const navigate = useNavigate();
  const location = useLocation();


  /* =================================================
     URL PARAMS
  ================================================= */

  const searchParams =
    new URLSearchParams(
      location.search
    );

  const redirectPath =
    searchParams.get('redirect') || '';

  const playerName =
    searchParams.get('name') || '';

  const safeRedirectPath =
    redirectPath.startsWith('/')
      ? redirectPath
      : '';


  /* =================================================
     STATE
  ================================================= */

  const [form, setForm] =
    useState({
      name: playerName,
      password: ''
    });

  const [loggingIn, setLoggingIn] =
    useState(false);


  /* =================================================
     INPUT
  ================================================= */

  const handleChange = event => {

    const {
      name,
      value
    } = event.target;

    setForm(current => ({
      ...current,
      [name]: value
    }));
  };


  /* =================================================
     PASSWORD LOGIN
  ================================================= */

  const handleSubmit =
    async event => {

      event.preventDefault();

      if (loggingIn) {
        return;
      }

      try {

        setLoggingIn(true);


        const response =
          await fetch(
            `${API_BASE}/api/users/login`,
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json'
              },

              body:
                JSON.stringify({
                  name:
                    form.name.trim(),

                  password:
                    form.password
                })
            }
          );


        const data =
          await response
            .json()
            .catch(() => ({}));


        if (!response.ok) {

          throw new Error(
            data.message ||
            data.error ||
            'เข้าสู่ระบบไม่สำเร็จ'
          );

        }


        if (
          !data.token ||
          !data.user
        ) {

          throw new Error(
            'Server ไม่ได้ส่งข้อมูล Login กลับมาครบ'
          );

        }


        /* ================= SAVE LOGIN ================= */

        localStorage.setItem(
          'token',
          data.token
        );


        localStorage.setItem(
          'user',
          JSON.stringify(
            data.user
          )
        );


        /* ================= SOCKET ================= */

        try {

          connectSocket(
            data.token
          );

        } catch (socketError) {

          console.warn(
            '[LOGIN SOCKET]',
            socketError
          );

        }


        /* =================================================
           ถ้ามาจาก Player History
        ================================================= */

        if (safeRedirectPath) {

          navigate(
            safeRedirectPath,
            {
              replace: true
            }
          );

          return;
        }


        /* =================================================
           LOGIN ปกติ
        ================================================= */

        const role =
          String(
            data.user?.role || ''
          )
            .trim()
            .toLowerCase();


        if (role === 'admin') {

          navigate(
            '/dashboard',
            {
              replace: true
            }
          );

        } else {

          navigate(
            '/profile',
            {
              replace: true
            }
          );

        }


      } catch (error) {

        console.error(
          '[LOGIN ERROR]',
          error
        );


        alert(
          error.message ||
          'เข้าสู่ระบบไม่สำเร็จ'
        );


      } finally {

        setLoggingIn(false);

      }

    };


  /* =================================================
     REGISTER
  ================================================= */

  const openRegister = () => {

    if (safeRedirectPath) {

      navigate(
        `/register?redirect=${encodeURIComponent(
          safeRedirectPath
        )}`
      );

      return;

    }


    navigate(
      '/register'
    );

  };


  /* =================================================
     BACK PLAYER HISTORY
  ================================================= */

  const backToPlayer = () => {

    if (!safeRedirectPath) {
      return;
    }


    navigate(
      safeRedirectPath,
      {
        replace: true
      }
    );

  };


  /* =================================================
     RENDER
  ================================================= */

  return (

    <div className="login-container">

      <div className="login-card">


        {/* ================= LOGO ================= */}

        <div className="login-logo">
          🏸
        </div>


        <h2>
          BADMINTON SPORT
        </h2>


        <p className="login-sub">

          {
            safeRedirectPath
              ? 'เข้าสู่ระบบเพื่อยืนยันตัวตนและเพิ่มรูปผู้เล่น'
              : 'เข้าสู่ระบบเพื่อเริ่มการแข่งขัน'
          }

        </p>


        {/* =================================================
           PLAYER HISTORY NOTICE
        ================================================= */}

        {safeRedirectPath && (

          <div
            style={{
              marginBottom: 16,
              padding: '10px 14px',
              borderRadius: 10,

              background:
                'rgba(59,130,246,0.12)',

              border:
                '1px solid rgba(59,130,246,0.3)',

              color:
                '#bfdbfe',

              fontSize: 13
            }}
          >

            🔐 กรุณา Login
            ด้วยบัญชีของผู้เล่น
            ก่อนเพิ่มรูป

          </div>

        )}


        {/* ================= FORM ================= */}

        <form
          onSubmit={
            handleSubmit
          }

          className="login-form"
        >


          {/* ================= USERNAME ================= */}

          <div className="input-group">

            <label>
              ชื่อผู้เล่น
            </label>


            <input
              type="text"

              name="name"

              value={
                form.name
              }

              placeholder="
                กรอกชื่อของคุณ
              "

              onChange={
                handleChange
              }

              autoComplete="
                username
              "

              required
            />

          </div>


          {/* ================= PASSWORD ================= */}

          <div className="input-group">

            <label>
              รหัสผ่าน
            </label>


            <input
              type="password"

              name="password"

              value={
                form.password
              }

              placeholder="
                กรอกรหัสผ่าน
              "

              onChange={
                handleChange
              }

              autoComplete="
                current-password
              "

              required
            />

          </div>


          {/* ================= LOGIN BUTTON ================= */}

          <button
            type="submit"

            className="
              login-btn
            "

            disabled={
              loggingIn
            }
          >

            {
              loggingIn
                ? 'กำลังเข้าสู่ระบบ...'
                : '🔐 เข้าสู่ระบบ'
            }

          </button>

        </form>


        {/* ================= DIVIDER ================= */}

        <div className="login-divider">

          <span>
            หรือ
          </span>

        </div>


        {/* =================================================
           LINE LOGIN - DISABLED
        ================================================= */}

        <button
          type="button"

          className="
            line-login-btn
            line-login-disabled
          "

          disabled

          aria-disabled="true"

          title="
            LINE Login
            ยังไม่เปิดให้ใช้บริการ
          "
        >

          <span
            className="
              line-login-mark
            "

            aria-hidden="
              true
            "
          >

            LINE

          </span>


          <span className="line-login-text">

            <strong>
              เข้าสู่ระบบด้วย LINE
            </strong>

            <small>
              ยังไม่เปิดให้ใช้บริการ
            </small>

          </span>

        </button>


        {/* ================= REGISTER ================= */}

        <p className="register-link">

          ยังไม่มีบัญชี?{' '}


          <span
            role="button"

            tabIndex={0}

            onClick={
              openRegister
            }

            onKeyDown={
              event => {

                if (
                  event.key ===
                  'Enter'
                ) {

                  openRegister();

                }

              }
            }
          >

            สมัครสมาชิก

          </span>

        </p>


        {/* ================= MONITOR ================= */}

        <p className="monitor-link">

          🖥️{' '}


          <span
            role="button"

            tabIndex={0}

            onClick={() =>
              navigate(
                '/monitor/1'
              )
            }

            onKeyDown={
              event => {

                if (
                  event.key ===
                  'Enter'
                ) {

                  navigate(
                    '/monitor/1'
                  );

                }

              }
            }
          >

            ดูหน้าจอการแข่งขัน

          </span>

        </p>


        {/* ================= BACK PLAYER ================= */}

        {safeRedirectPath && (

          <p className="monitor-link">

            ↩️{' '}


            <span
              role="button"

              tabIndex={0}

              onClick={
                backToPlayer
              }

              onKeyDown={
                event => {

                  if (
                    event.key ===
                    'Enter'
                  ) {

                    backToPlayer();

                  }

                }
              }
            >

              กลับหน้าประวัติผู้เล่น

            </span>

          </p>

        )}


      </div>

    </div>

  );

}


export default Login;